import type { GetCancellationsResponse } from '@/types/cancellation'
import type { Options } from 'ky'
import { httpClient } from '@/utils/http'

export const cancellationService = {
  cancellations: (options?: Options) =>
    httpClient.get('cancellations', options).json<GetCancellationsResponse>(),
}
